import { amountOfLastDigitsForName } from '../constants/app';

export function generateNameByRegionTypeAndMAC(
  region: string,
  mac: string,
  type: string,
): string {
  let reg = region ? region : 'REGION';
  let macWithoutDashesAndColons = mac.replace(/[. :-]/g, '');
  let lastSixDigitsOfMac = mac
    ? macWithoutDashesAndColons.slice(-amountOfLastDigitsForName)
    : 'LAST-6-DIGITS-OF-MAC';
  let deviceType = type ? type : 'TYPE';
  deviceType = deviceType === 'Mac Mini' ? 'macmini' : deviceType;

  return reg + '-' + deviceType + '-' + lastSixDigitsOfMac;
}

export function getRegion(deviceName: string): string {
  const nameByPart = deviceName.split('-');
  return nameByPart[0];
}

export function getType(deviceName: string): string {
  const nameByPart = deviceName.split('-');
  const deviceType = nameByPart[1] === 'macmini' ? 'Mac Mini' : nameByPart[1];
  return deviceType;
}
